module.exports = __webpack_public_path__ + "img/Dual-chip.103c5e51.png";